import { createContext } from 'react';

export const ContentGroupContext = createContext();

export function ContentGroupProvider({ 
  children, 
  ...props
 }) {

  let values ={
    ...props
  }

  return (
    <ContentGroupContext.Provider value={values}>
      {children}
    </ContentGroupContext.Provider>
  )
}